var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-2xl w-full mx-auto pt-16"},[_c('img',{staticClass:"w-full",attrs:{"alt":"creating event","src":_vm.asset('images/events/creating-event-animation.svg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }